import arrowBigDownIcon from "@tabler/icons/outline/arrow-big-down.svg";
import arrowBigUpIcon from "@tabler/icons/outline/arrow-big-up.svg";
import React from "react";
import { defineMessages, useIntl } from "react-intl";

import { useStatusActions } from "@/hooks";

import StatusActionGroup, {
  type StatusActionLayout,
} from "./status-action-group";

import type { Status } from "@/schemas";

const messages = defineMessages({
  downvote: { id: "status.downvote", defaultMessage: "Downvote" },
  upvote: { id: "status.upvote", defaultMessage: "Upvote" },
});

interface StatusReactionsProps {
  status: Status;
  layout: StatusActionLayout;
}

export default function StatusReactions(props: StatusReactionsProps) {
  const { layout, status } = props;

  const intl = useIntl();

  const { handleUpvote, handleDownvote, isLoading } = useStatusActions({
    status,
  });

  return (
    <StatusActionGroup
      layout={layout}
      primaryAction={{
        iconSrc: arrowBigUpIcon,
        handler: handleUpvote,
        active: status.reaction === "upvote",
        isFilledOnActive: true,
        color: "accent",
        count: status.upvotes_count,
        disabled: isLoading,
        "aria-label": intl.formatMessage(messages.upvote),
      }}
      secondaryAction={{
        iconSrc: arrowBigDownIcon,
        handler: handleDownvote,
        active: status.reaction === "downvote",
        isFilledOnActive: true,
        color: "primary",
        count: status.downvotes_count,
        disabled: isLoading,
        "aria-label": intl.formatMessage(messages.downvote),
      }}
    />
  );
}
